import { Button, Input } from '@material-tailwind/react'
import React from 'react'

const EditHomeForm = ({addImage,homeCarousel,homeImage,setHomeImage,homeName,setHomeName,homeContent,setHomeContent,homeLink,setHomeLink,addHomeCarousel}) => {
  return (
    <div className='ml-[20rem] py-6' >
        <div className='' >
            <h3 className='font-[NeueBold] text-[2rem] ' >Home Content</h3>
            <div className='bg-white py-3 my-3 px-6 rounded-lg' >
                <h3 className='font-[NeueMedium]' >Home Banner Images</h3>
                <div>
                <div className='my-3' >
                    <Input value={homeName} onChange={(e)=>setHomeName(e.target.value)}  label='Enter Image Name' />
                </div>
                <div className='my-3' >
                    <Input value={homeContent} onChange={(e)=>setHomeContent(e.target.value)} label='Enter Image Content' />
                </div>
                <div className='my-3'>
                    <Input value={homeLink} onChange={(e)=>setHomeLink(e.target.value)} label='Enter Image Link' />
                </div>
        <div>
                     <form  onSubmit={addImage} className='form flex items-center justify-center flex-col my-6 '>
        <input type='file' />
        <Button className='my-6' type='submit' size="md">Upload Image</Button>
      </form>
      
                </div>
                <div className='flex items-center justify-center gap-6' >
                   
                        { homeImage.length !==0 &&   <div className='flex items-center justify-start gap-6' >
                                <img className='w-[200px] h-[200px]' src={homeImage} />
                            </div>}
                        
                  
                </div>
                <div className='flex items-center justify-end' >
                    <Button onClick={addHomeCarousel} >Submit</Button>
                </div>
        </div>
            </div>
           
        </div>
    </div>
  )
}

export default EditHomeForm